import InboxPage from './views/InboxPage.vue';

const routes = [
  {
    path: '/inbox',
    name: 'inbox',
    component: InboxPage,
    meta: {
      title: 'Boîte de réception',
      requiresAuth: true,
      headerColor: '#ffffff',
      showBackButton: false
    }
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: InboxPage,
    meta: {
      title: 'Notifications',
      requiresAuth: true,
      headerColor: '#ffffff',
      showBackButton: true
    }
  }
];

export default routes;
